import { TableRow } from '@mui/material'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import React from 'react'
import { useIntl } from 'react-intl'

const ReportHeader: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <TableRow>
      <TableHeaderCell minWidth={TableCellWidth.LARGE} label={formatMessage({ id: 'schemas.requestTemplate.title' })} />
      <TableHeaderCell
        label={formatMessage({ id: 'automations.flagNumberHeader' })}
        minWidth={TableCellWidth.EXTRA_SMALL}
      />
    </TableRow>
  )
}

export default ReportHeader
